<template>
    <div class="drawerLayer" v-show="visible">
        <div class="mask" @click="close();"></div>
        <div class="bottomDrawer white_bg">
            <div class="generalPagePaddingH">
                <header class="header paddingV16">
                    <div class="flexLayout">
                        <div style="width: 16px;">
                            <i class="icon closeIcon" @click="close()"></i>
                        </div>
                        <div class="flexItem alignCenter grey10 bold">绑定结果</div>
                        <div style="width: 16px;">
<!--                            <i class="icon closeIcon" @click="close()"></i>-->
                        </div>
                    </div>
                </header>
                <div class="body" style="padding-bottom: 38px;">
                    <div class="alignC" style="padding: 38px 38px 0;">
                        <img class="icon size48" src="integral/success_yellow_circle_icon.png"/><br/>
                        <div class="font18r grey20 bold marginT8">绑定成功</div>

                        <div class="font12r" style="margin-top: 64px; color: hsla(219, 16%, 60%, 1)">
                            <img class="icon size12" src="integral/notice_red_circle_icon.png"/>
<!--                            <span style="color: hsla(2, 100%, 61%, 1)">礼品学分</span>-->
<!--                            将自动充值到您的账号<br/>-->
<!--                            学分到账可能存在延迟，请耐心等待-->
                        </div>

                        <button class="button okButton bold marginT16" @click="ok()">确定</button>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
import drawerPart from '@comp/part/drawerPart';

const config = {
};

export default {
    name: "bindPhoneSuccessDrawer",
    extends : drawerPart,
    data() {
        return {
        }
    },
    methods : {
        ok() {
            this.close();
            this.$emit('ok');
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    .closeIcon {
        width: 14px;
        height: 14px;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACFklEQVRoge2ZQU/bMBhALWCdhPgZvfnk7305k/MkdhgwumqI/vkxpE2CaTsgtaG7xCjqbEiKnWRSntRDqzp+L0nbNDZmYmIiCHBsrT0Z2sNaewIcdxqkqh+AP8CjiHzO5PYqIvIJeAR+q2rZdtwhcAts68daVc8zegZR1Qtg3fC4NcYcvDoQeAc8NAb6iIv82s8OlzvyW+DeGHPYdgNLEakCEdmPRGDPb4EnEbnqtCERWfUdISJXEfnVvhsMRgCXadWf5TfJ5BsbDkVsnHNf0qhnlG9MkC0iu3xjouQRIfl6jpuU7s0Jk0XE5FX1Ood7c+I3Rwwm3xDYO8I5txhU3rNPBLAEqsHlPV0iRifvaRMxWnnPSxEheWA88p5YROC1ClgO7RtERL4GflX/D3lPfdr8E1EfiXHLG2OMql4HTpvkF4BZeEF+/BEh+fr57uk0vojInq+AZeQzMZ6IiPzGObfw74lFJL/m70pMPvQHPBQhItVgEV3kPaOJAG66ynsGjxCRFfC0j7xnsIgU8p7eI1LKe3qLiMiv3yLvyR4Rk095szdbRB/ynuQRfcp7kkWo6qJveQ+BtYE6ot1KkbV2BvzalSfDHekYkTWCe2vtrM34A+B786uyz9UZj6qe70R8M22WmIwxpiiKU+AO+CEiZ3lV4zjnPgI/gbuiKE47DS7L8mg+n7/P5NYaa+2sLMujoT0mJsbKX2RBsPwpegpvAAAAAElFTkSuQmCC');
    }
}
.okButton {
    width: 100%;
    height: 42px;
    line-height: 42px;
    background: linear-gradient(270deg, #FFBD5A 0%, #FF8853 100%);

    border: none;

    border-radius: 21px;
    font-size: 16px;
    color: white;
}
</style>
